/* start - flights_split_bounds_us */
import { StoreState } from "store";

export const getSearchFetchStatus = (state: StoreState) => state.searchResultsBounds.inbound.fetchStatus;
export const getSearchResultsFlights = (state: StoreState) => state.searchResultsBounds.inbound.flights;
export const getSearchPointOfSale = (state: StoreState) =>
  state.searchResultsBounds?.inbound?.flights?.[0]?.pointOfSale;
export const getSearchResultsFetchedAt = (state: StoreState) => state.searchResultsBounds.inbound.fetchedAt;
export const getSearchResultsFlightOffers = (state: StoreState) => state.searchResultsBounds.inbound.flights;
export const getSearchResultsFlightDeals = (state: StoreState) => state.searchResultsBounds.inbound.flightDeals;
export const getSearchId = (state: StoreState) => state.searchResultsBounds.inbound.searchId;
export const getSearchAvailableFilters = (state: StoreState) => state.searchResultsBounds.inbound.availableFilters;
export const getSearchDisplayOptions = (state: StoreState) => state.searchResultsBounds.inbound.displayOptions;
export const getAvailableFilters = (state: StoreState) => state.searchResultsBounds.inbound.availableFilters || {};
export const getSearchResultsBanners = (state: StoreState) => state.searchResultsBounds.inbound.banners;
export const getSearchResultsError = (state: StoreState) => state.searchResultsBounds.inbound.error;
export const getSearchResultsSubsidizedFaresSummary = (state: StoreState) =>
  state.searchResultsBounds.inbound.subsidizedFaresSummary;
export const getSearchResultsSearchCriteria = (state: StoreState) => state.searchResultsBounds.inbound.searchCriteria;
export const getSearchResultsAtolProtectedStatus = (state: StoreState) =>
  state.searchResultsBounds.inbound.atolProtectedStatus;
export const getSearchResultsBaggagePolicies = (state: StoreState) => state.searchResultsBounds.inbound.baggagePolicies;
export const getSearchResultsCampaignBanner = (state: StoreState) => state.searchResults.campaignBanner;
export const getSearchResultsRemoteBanners = (state: StoreState) => state.searchResults.remoteBanners;
/* end - flights_split_bounds_us */
